module.exports = __webpack_public_path__ + "assets/img/2.1fb79926.png";